var map = {
	"./1.jpg": 1613,
	"./2.jpg": 1614,
	"./3.jpg": 1615,
	"./4.jpg": 1616,
	"./5.jpg": 1617,
	"./6.jpg": 1618,
	"./7.jpg": 1619
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1612;